import { h as n, computed as a } from "vue";
const d = {
  transform: "rotate(var(--r, 0deg)) scale(var(--sx, 1), var(--sy, 1))"
}, u = {
  fill: "currentColor"
}, c = {
  mdi: {
    size: 24,
    viewbox: "0 0 24 24"
  },
  "simple-icons": {
    size: 24,
    viewbox: "0 0 24 24"
  },
  default: {
    size: 0,
    viewbox: "0 0 0 0"
  }
}, g = {
  name: "icon",
  props: {
    type: {
      type: String,
      default: "mdi"
    },
    faIcon: {
      type: Object,
      default: null
    },
    path: {
      type: [String, Object, Array]
    },
    size: {
      type: [Number, String],
      default: 24
    },
    viewbox: String,
    flip: {
      type: String,
      validator: (e) => ["horizontal", "vertical", "both"].includes(e)
    },
    rotate: {
      type: [Number, String],
      default: 0
    }
  },
  setup(e) {
    if (!e.path && !e.faIcon)
      return console.warn("vue3-icon requires either a 'path' or an 'fa-icon' property"), () => n("div");
    const l = a(() => {
      var t;
      return ((t = e.faIcon) == null ? void 0 : t.prefix) || e.type;
    }), i = a(() => parseInt(e.rotate, 10)), r = a(() => c[l.value] || c.default), o = a(() => parseInt(e.size, 10) || r.value.size), s = a(() => e.faIcon ? `0 0 ${e.faIcon.icon[0]} ${e.faIcon.icon[1]}` : !1), f = a(() => s.value || e.viewbox || r.value.viewbox), v = a(() => ({
      ...d,
      "--sx": ["both", "horizontal"].includes(e.flip) ? "-1" : "1",
      "--sy": ["both", "vertical"].includes(e.flip) ? "-1" : "1",
      "--r": isNaN(i.value) ? i.value : i.value + "deg"
    })), h = a(() => {
      var t;
      return e.faIcon ? (t = e.faIcon) == null ? void 0 : t.icon[4] : e.type === "simple-icons" && typeof e.path == "object" ? e.path.path : e.path;
    }), y = a(() => l.value === "fad" ? (console.warn("vue3-icon does not currently support Duotone FontAwesome icons"), n("path")) : Array.isArray(e.path) ? n(
      "g",
      { style: { ...u } },
      e.path.map((t) => typeof t == "string" ? n("path", { d: t }) : n("path", { ...t }))
    ) : n("path", { d: h.value, style: { ...u } }));
    return () => n(
      "svg",
      {
        style: v.value,
        class: ["vue3-icon"],
        width: o.value,
        height: o.value,
        viewBox: f.value
      },
      [y.value]
    );
  }
};
export {
  g as default
};
